import { useEffect, useState } from "react"
import useFetchData from "./data/useFetchUserData";
import useFetchUserBalance from "./data/useFetchUserBalance";
import { useDispatch } from "react-redux";
import { SetUserData } from "src/redux/reducers/userDataReducer";
import { SetUserBalance } from "src/redux/reducers/balanceReduser";
import useFetchUserOrders from "./data/useFetchUserOrders";
import { SetOrders } from "src/redux/reducers/ordersReduser";

const useUserData = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const { fetchUserData } = useFetchData();
  const { getUserBalance } = useFetchUserBalance();
  const { getUserOrders } = useFetchUserOrders();
  const dispatch = useDispatch();

  useEffect(() => {
    async function getUserData() {
      const responseUserData = await fetchUserData();
      dispatch(SetUserData(responseUserData));

      const responseBalance = await getUserBalance(responseUserData.telegramId);
      if (responseBalance.status) {
        dispatch(SetUserBalance(responseBalance.balance));
      }

      const responceUserOrders = await getUserOrders(responseUserData.telegramId);
      if (responceUserOrders.status) {
        dispatch(SetOrders(responceUserOrders.orders));
      }

      setLoading(false)
    }

    getUserData();
  }, [])

  return [loading]
}

export default useUserData;